import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Button } from 'antd';

import type { ProductOffer } from 'v2/interfaces/product';

function Header() {
  const history = useHistory();
  const location = useLocation<{ offer: ProductOffer }>();
  const offer = location.state?.offer;

  function handleBack() {
    history.goBack();
  }

  return (
    <header className='flex items-center justify-between'>
      <h1 className='text-2xl font-semibold'>{offer.name}</h1>
      <Button id='back-button' onClick={handleBack}>
        Voltar
      </Button>
    </header>
  );
}

export { Header };
